// Mock data for GalerieCop clone

export const eventCategories = [
  {
    id: "weddings",
    title: "Weddings",
    image: "https://images.unsplash.com/photo-1583939003579-730e3918a45a?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
    href: "/weddings"
  },
  {
    id: "parties",
    title: "Parties",
    image: "https://images.unsplash.com/photo-1699730164892-d7c433524ff3?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
    href: "/party"
  },
  {
    id: "business",
    title: "Business",
    image: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
    href: "/business"
  },
  {
    id: "memorials",
    title: "Memorials",
    image: "https://images.unsplash.com/photo-1527529482837-4698179dc6ce?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
    href: "/memorials"
  },
  {
    id: "engagements",
    title: "Engagements",
    image: "https://images.unsplash.com/photo-1606800052052-a08af7148866?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
    href: "/engagements"
  },
  {
    id: "kids-parties",
    title: "Kids Parties",
    image: "https://images.unsplash.com/photo-1517457373958-b7bdd4587205?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
    href: "/kids-parties"
  }
];

export const pricingTabs = [
  { id: "wedding", label: "Wedding Pricing", href: "/weddings-pricing" },
  { id: "engagement", label: "Engagement Pricing", href: "/engagements-pricing" },
  { id: "party", label: "Party Pricing", href: "/party-pricing" },
  { id: "business", label: "Business Pricing", href: "/business-pricing" },
  { id: "memorial", label: "Memorial Pricing", href: "/memorials-pricing" },
  { id: "kids", label: "Kids Party Pricing", href: "/kids-party-pricing" }
];

export const stats = [
  {
    number: "150k+",
    title: "Global Events",
    description: "Trusted by amazing hosts just like you \u2013 in over 100 countries."
  },
  {
    number: "millions",
    title: "of memories captured",
    description: "Helping you capture the moments you don\u2019t want to miss \u2013 one photo, video and guestbook message at a time."
  },
  {
    number: "#1",
    title: "The OG",
    description: "The original QR Code digital guest platform purpose-built to help hosts turn moments into lifelong memories."
  }
];

export const asSeenIn = [
  "marie claire",
  "THE BRIDAL JOURNEY",
  "the knot",
  "COSMOPOLITAN",
  "polka dot wedding",
  "BRIDES",
  "VOGUE",
  "HARPER\u2019S BAZAAR"
];

export const galleryImages = [
  "https://images.unsplash.com/photo-1520854221256-17451cc331bf?crop=entropy&cs=srgb&fm=jpg&w=600&q=80",
  "https://images.unsplash.com/photo-1583939003579-730e3918a45a?crop=entropy&cs=srgb&fm=jpg&w=600&q=80",
  "https://images.unsplash.com/photo-1606800052052-a08af7148866?crop=entropy&cs=srgb&fm=jpg&w=600&q=80",
  "https://images.unsplash.com/photo-1517457373958-b7bdd4587205?crop=entropy&cs=srgb&fm=jpg&w=600&q=80",
  "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?crop=entropy&cs=srgb&fm=jpg&w=600&q=80",
  "https://images.unsplash.com/photo-1527529482837-4698179dc6ce?crop=entropy&cs=srgb&fm=jpg&w=600&q=80",
  "https://images.unsplash.com/photo-1699730164892-d7c433524ff3?crop=entropy&cs=srgb&fm=jpg&w=600&q=80",
  "https://images.unsplash.com/photo-1565849904461-04a58ad377e0?crop=entropy&cs=srgb&fm=jpg&w=600&q=80"
];

export const heroImage = "https://images.unsplash.com/photo-1583939003579-730e3918a45a?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85";

export const howItWorks = [
  {
    step: "01",
    title: "Create your event",
    description: "Sign up, name your event and customize your private gallery in under 2 minutes."
  },
  {
    step: "02",
    title: "Share your QR code",
    description: "Display your custom QR code or share your private link with guests \u2013 no app required."
  },
  {
    step: "03",
    title: "Guests scan & upload",
    description: "Guests scan, upload photos, videos and guestbook messages directly to your gallery."
  },
  {
    step: "04",
    title: "Download everything",
    description: "Enjoy every memory in one place. Download in original resolution whenever you\u2019re ready."
  }
];

export const languages = [
  { code: "EN", label: "English" },
  { code: "DE", label: "Deutsch" },
  { code: "ES", label: "Espa\u00f1ol" },
  { code: "FR", label: "Fran\u00e7ais" },
  { code: "IT", label: "Italiano" },
  { code: "JA", label: "\u65e5\u672c\u8a9e" },
  { code: "KO", label: "\ud55c\uad6d\uc5b4" },
  { code: "NL", label: "Nederlands" },
  { code: "PT", label: "Portugu\u00eas" },
  { code: "ZH", label: "\u4e2d\u6587" }
];

export const pricingPlans = {
  wedding: [
    {
      name: "Petite",
      price: "$35",
      tag: "Intimate gatherings",
      features: [
        "1 Event Gallery",
        "1 QR Code + 1 Invite & With RSVPs",
        "Default Design Theme",
        "Up to 1,000 Photos & Videos",
        "Content Moderation",
        "3 Mo. Upload & 12 Mo. Hosting",
        "Hosting Starts From Event Date",
        "Unlimited Guests & Co-Hosts",
        "Interactive private feed (Likes/Comments)",
        "Multi-lingual (EN/FR/ES/DE/IT/JP + 5 More)",
        "100% Copyright Stays With You",
        "180+ Editable QR Code Canva Templates",
        "Enterprise Security & Data Practices",
        "High Speed, Premium Cloud Connectivity",
        "14 Day Money Back Guarantee",
        "7-Day Real Customer Care Team"
      ],
      popular: false
    },
    {
      name: "Classic",
      price: "$55",
      tag: "Most popular",
      features: [
        "1 Event Gallery",
        "1 QR Code + 1 Invite & With RSVPs",
        "Custom Color Theme And Fonts",
        "Unlimited Super Albums",
        "Up to 5,000 Photos & Videos",
        "Content Moderation",
        "12 Mo. Upload & Hosting",
        "Hosting Starts From Event Date",
        "Unlimited Guests & Co-Hosts",
        "Interactive private feed (Likes/Comments)",
        "Multi-lingual (EN/FR/ES/DE/IT/JP + 5 More)",
        "100% Copyright Stays With You",
        "180+ Editable QR Code Canva Templates",
        "Enterprise Security & Data Practices",
        "High Speed, Premium Cloud Connectivity",
        "14 Day Money Back Guarantee",
        "7 Day Real Customer Care Team"
      ],
      popular: true
    },
    {
      name: "Grand",
      price: "$120",
      tag: "Large celebrations",
      features: [
        "3 Separate Event Galleries",
        "3 QR Codes + 3 Invites & With RSVPs",
        "Custom Color Theme And Fonts",
        "Unlimited Super Albums",
        "Unlimited Photos & Videos",
        "Content Moderation",
        "12 Mo. Upload & Hosting",
        "Hosting Starts From Date Of Purchase",
        "Unlimited Guests & Co-Hosts",
        "Interactive private feed (Likes/Comments)",
        "Multi-lingual (EN/FR/ES/DE/IT/JP + 5 More)",
        "100% Copyright Stays With You",
        "180+ Editable QR Code Canva Templates",
        "Enterprise Security & Data Practices",
        "High Speed, Premium Cloud Connectivity",
        "14 Day Money Back Guarantee",
        "7-Day Real Customer Care Team"
      ],
      popular: false
    }
  ]
};
